import { OvlAddComponent } from "../../../../_ovlclient/src/global/globals"
import { CompSYSUserSettingsPasswordForm } from "./parts/passwordsettingsform"

export const SYSUserSettingsPassword_Init = () => {
  OvlAddComponent(
    "comp-sysusersettingspasswordform",
    CompSYSUserSettingsPasswordForm
  )
}
